import type { IAttributes, IAugmentedJQuery, IDirective, IParseService, IScope } from "angular";
import { module } from "angular";

export default class OnImgLoadedDirective implements IDirective {
    public restrict: "A";

    public constructor(private readonly $parse: IParseService) {}

    public link(scope: IScope, elem: IAugmentedJQuery, attrs: IAttributes) {
        const fn = this.$parse(attrs.irOnImgLoaded);
        elem.on("load", () => {
            scope.$apply(() => {
                fn(scope, { $event: window.event });
            });
        });
    }
}

module("mmManagePortal").directive("irOnImgLoaded", [
    "$parse",
    ($parse: IParseService) => new OnImgLoadedDirective($parse),
]);
